// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Card_avatar__J_1JH","img":"Card_img__3uKiN","title":"Card_title__2t3FQ","counter":"Card_counter__3Vu5H","button":"Card_button__2YHzL"};